import { migrateLegacyColumnWidths } from '@/utils/warehouseTableHelpers'

export const WAREHOUSE_SKU_CROSSWALK_PAGE_KEY = 'warehouse-sku-crosswalk'

export const WAREHOUSE_SKU_CROSSWALK_COLUMN_KEYS = [
  'bk_sku',
  'wh_sku',
  'display_name',
  'units_per_case',
  'casesLeft',
  'avgCost',
  'actions',
] as const

export const WAREHOUSE_SKU_CROSSWALK_DEFAULT_WIDTHS: Record<string, number> = {
  bk_sku: 120,
  wh_sku: 110,
  display_name: 220,
  units_per_case: 120,
  casesLeft: 150,
  avgCost: 150,
  actions: 56,
}

export function migrateWarehouseSkuCrosswalkColumnWidths(): void {
  migrateLegacyColumnWidths(
    WAREHOUSE_SKU_CROSSWALK_PAGE_KEY,
    [],
    WAREHOUSE_SKU_CROSSWALK_COLUMN_KEYS
  )
}
